/**
 * Umsatzsteuer in der Oberflaeche.
 *
 * Eingetragen wird immer der BRUTTO-Betrag — das ist der, der auf dem
 * Kontoauszug steht. Netto und Steueranteil sind daraus gerechnet und dienen
 * nur der Anzeige; gerechnet wird serverseitig noch einmal, damit beides nicht
 * auseinanderlaufen kann.
 */

import { formatEuro } from '@elbklar/ui';

/** Vollständiger Betrag mit Cent, wie im Betragsfeld darüber. */
const euro = (betrag: number) => formatEuro(betrag, { cent: true });

export const STEUERSAETZE = [
  { value: '0', label: 'Ohne Umsatzsteuer' },
  { value: '7', label: '7 %, ermäßigt' },
  { value: '19', label: '19 %, Regelsatz' },
];

/** Der im Bruttobetrag steckende Steueranteil, Vorzeichen folgt dem Betrag. */
export function steueranteil(brutto: number, satz: number): number {
  if (!satz) return 0;
  return (brutto * satz) / (100 + satz);
}

export function netto(brutto: number, satz: number): number {
  return brutto - steueranteil(brutto, satz);
}

/**
 * Die Zeile unter dem Betragsfeld, als `hinweis` an `Betragsfeld`.
 *
 * Steht eine Zahl im Feld und ist ein Steuersatz gewählt: Netto und
 * Steueranteil, also was wirklich vom Konto geht und was davon zurückkommt.
 * Das Ergebnis einer Rechnung setzt das Betragsfeld selbst davor. Ohne Zahl
 * steht `leer` da, ohne Steuersatz nichts: das Offensichtliche zu wiederholen
 * macht die Maske nur unruhig.
 */
export function steuerHinweis(wert: number | null, satzEingabe: string, leer?: string): string | undefined {
  if (wert === null) return leer;
  const brutto = Math.abs(wert);
  const satz = Number(satzEingabe);
  if (!satz || !brutto) return undefined;
  return `${euro(netto(brutto, satz))} netto · ${euro(steueranteil(brutto, satz))} Umsatzsteuer`;
}

/** "19 %" — für Tabellen; ohne Satz bleibt die Spalte still. */
export function satzText(satz: string | null | undefined): string {
  const wert = Number(satz ?? 0);
  return wert ? `${wert.toLocaleString('de-DE')} %` : '–';
}

/** Voranmeldezeitraum in Worten. */
export function zeitraumText(monate: number): string {
  return monate === 3 ? 'quartalsweise' : 'monatlich';
}
